const STAGES = [
  { range: "0\u201306 months", title: "Prove Rooms" },
  { range: "7\u201312 months", title: "Extend to People & Network" },
  { range: "13\u201318 months", title: "Connect & Simplify" },
  { range: "19\u201324 months", title: "Optimise & Retire" },
];

export const ExecRoadmap = () => (
  <div className="exec-roadmap" data-testid="exec-roadmap-visual">
    {STAGES.map((s, i) => (
      <div className="exec-roadmap-stage" key={s.title}>
        <div className="exec-roadmap-range">{s.range}</div>
        <div className="exec-roadmap-title">{s.title}</div>
        {i < STAGES.length - 1 && <span className="exec-roadmap-arrow" aria-hidden="true">{"\u2192"}</span>}
      </div>
    ))}
  </div>
);
